import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import MainPage from './pages/MainPage.vue'
import MenuPage from './pages/MenuPage.vue'
import GurtniPage from './pages/GurtniPage.vue';
import RedonyPage from "@/pages/RedonyPage.vue";
import SzunyoghhaloPage from "@/pages/SzunyoghhaloPage.vue";
import AOS from 'aos'
import 'aos/dist/aos.css'

const routeInfos = [{
        path: "/",
        component: MainPage
    },
    {
        path: "/termekek/",
        component: MenuPage
    },
    {
        path: "/gurtnicsere/",
        component: GurtniPage
    },
    {
        path: "/redonyok/",
        component: RedonyPage
    },
    {
        path: "/szunyoghalok/",
        component: SzunyoghhaloPage
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes: routeInfos
})

const app = createApp(App)
app.use(router)
app.mount('#app')

// Initialize AOS for scroll animations
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
if (!prefersReducedMotion) {
  AOS.init({
    duration: 800,
    easing: 'ease-in-out',
    once: true,
    offset: 100
  })
}